import { render, staticRenderFns } from "./W2HButton.vue?vue&type=template&id=4dfce25f&"
import script from "./W2HButton.vue?vue&type=script&lang=js&"
export * from "./W2HButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports